/**
 * Le fond d'une pastille — l'`Avatar` d'une boutique comme celui d'une
 * personne.
 *
 * ⚠️ La couleur n'est là QUE pour les initiales de repli : deux lettres sans
 * disque coloré derrière elles ne se détachent pas d'un fond clair. Elle était
 * posée en dur sur l'Avatar, donc elle restait aussi SOUS les visuels — sans
 * conséquence tant qu'un logo était aplati sur un fond opaque, flagrante
 * depuis qu'on lui conserve sa transparence : le logo de la boutique
 * s'affichait sur un carré bleu, dans l'entête comme sur les cartes du
 * sélecteur.
 *
 * ⚠️ `contain` plutôt que `cover` pour un logo : l'Avatar recadre par défaut
 * pour remplir sa pastille, ce qui rogne les bords — or un logo est dessiné
 * cadré, ses marges font partie du dessin. Une photo de personne, elle, gagne
 * au contraire à remplir.
 */
export function fondPastille(
  source: string | null | undefined,
  cadrage: 'contain' | 'cover' = 'contain',
): { bgcolor: string; '& .MuiAvatar-img'?: { objectFit: 'contain' | 'cover' } } {
  return source
    ? { bgcolor: 'transparent', '& .MuiAvatar-img': { objectFit: cadrage } }
    : { bgcolor: 'primary.main' }
}
